/* Pozca mobil tasarım CTA. Sepete eklemeye / customizer verilerine dokunmaz. */
(function () {
  'use strict';
  function init() {
    var bar = document.getElementById('pozca-sticky-cta');
    if (!bar) return;
    var btn = bar.querySelector('[data-pozca-open-builder]');
    var price = bar.querySelector('[data-pozca-price]');
    var media = window.matchMedia('(max-width: 768px)');
    // Her kontrolde yeniden bul: Shopify varyant degisiminde DOM'u yenileyebilir.
    function getOriginal() { return document.getElementById('iz-builder-open'); }
    function getPersonalization() { return document.querySelector('.iz-kisi'); }
    function getTarget() { return getOriginal() || getPersonalization(); }
    // Kisisellestirme olmayan urunlerde sepete ekleme/odeme kisayolu gosterilmez.
    if (!getTarget()) return;
    function modalVisible() {
      var modal = document.querySelector('.iz-bld:not(.iz-bld--hidden)');
      return !!modal;
    }
    function visibleInViewport(node) {
      var r = node.getBoundingClientRect();
      return r.top < window.innerHeight && r.bottom > 0;
    }
    function update() {
      var focused = document.activeElement;
      var typing = focused && focused.matches('input:not([type=radio]):not([type=checkbox]), textarea, select');
      bar.hidden = typing || !media.matches || window.scrollY < 280 || modalVisible() || !getTarget() || visibleInViewport(getTarget());
    }
    btn.addEventListener('click', function () {
      bar.hidden = true;
      var trigger = getOriginal();
      if (trigger) {
        trigger.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (typeof trigger.focus === 'function') trigger.focus({ preventScroll: true });
      } else {
        var form = getPersonalization();
        if (form) form.scrollIntoView({behavior:'smooth', block:'start'});
      }
    });
    window.addEventListener('scroll', update, {passive:true});
    window.addEventListener('resize', update, {passive:true});
    document.addEventListener('focusin', update);
    document.addEventListener('focusout', function () { window.requestAnimationFrame(update); });
    document.addEventListener('click', function () { window.requestAnimationFrame(update); });
    document.addEventListener('keydown', function () { window.requestAnimationFrame(update); });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (payload) {
        var v = payload && payload.data && payload.data.variant;
        if (!v || typeof v.price !== 'number' || !price) return;
        // Shopify variant.price kurus cinsindendir; para birimi tema tarafindan gosterilir.
        try {
          var c = bar.getAttribute('data-currency') || 'TRY';
          price.textContent = new Intl.NumberFormat('tr-TR', {style:'currency',currency:c}).format(v.price/100);
        } catch (e) { /* Orijinal Liquid fiyati korunur. */ }
      });
    }
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
}());
